import { useCallback, useEffect, useState } from 'react';
import PageContainer from '../components/PageContainer';
import { useDispatch } from 'react-redux';
import { useRefreshHandler } from '../components/pullToRefresh/useRefreshHandler';
import AdviceCategorySection from '../components/AdviceCategorySection';
// import HomepageWildSection from '../components/HomepageWildSection'; // sezione "Non trovi il tuo posto Wild preferito? Condividilo con noi" disattivata 2026-09-07 (richiesta cliente), componente conservato per eventuale riattivazione
import HomepageOwnerSection from '../components/HomepageOwnerSection';
import ActivityIconSection from '../components/ActivityIconSection';
import RegionIconSection from '../components/RegionIconSection';
import HeroCarousel from '../components/HeroCarousel';
import { setBacklink } from '../redux/backlinkSlice';
import DownloadAppFromStore from '../components/DownloadAppFromStore';
// import DownloadAppSection from '../components/DownloadAppSection'; // vecchia promo PWA (sostituita da DownloadAppFromStore)
import { emptyFilters } from '../redux/filtersSlice';
import PartnerBrands from '../components/PartnerBrands';
import usePageTracking from '../hooks/usePageTracking';
import { Helmet } from 'react-helmet-async';
import LastFiveSection from '../components/LastFiveSection';
import SearchBar from '../components/poolBar/SearchBar';
import SwisstainableSection from '../components/SwisstainableSection';

const HomePage = () => {

    usePageTracking({
        pageTitle: "Home"
    });

    // Imposto AllActivities per la Pool
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setBacklink("/"));
        dispatch(emptyFilters())
    }, [dispatch])

    // Pull-to-refresh (nativo): rinfresca i blocchi dinamici della home (carosello hero e
    // "ultime 5") bumpando il refreshSignal condiviso; le altre sezioni sono statiche/icone.
    const [homeRefreshSignal, setHomeRefreshSignal] = useState(0);
    useRefreshHandler(useCallback(() => setHomeRefreshSignal(prev => prev + 1), []));

    return (
        <PageContainer items="center">
            <Helmet>
                <title>TicinoWild - Idee outdoor in Ticino</title>
                <meta name="description" content="Scopri cosa fare in Ticino: posti per grigliare, punti panoramici, fiumi e laghetti alpini. Idee outdoor per il tempo libero." />
                <link rel="canonical" href="https://ticinowild.ch/" />
                <meta property="og:title" content="TicinoWild - Idee outdoor in Ticino" />
                <meta property="og:description" content="Scopri cosa fare in Ticino: posti per grigliare, punti panoramici, fiumi e laghetti alpini. Idee outdoor per il tempo libero." />
                <meta property="og:url" content="https://ticinowild.ch/" />
                <meta name="twitter:title" content="TicinoWild - Idee outdoor in Ticino" />
                <meta name="twitter:description" content="Scopri cosa fare in Ticino: posti per grigliare, punti panoramici, fiumi e laghetti alpini. Idee outdoor per il tempo libero." />
            </Helmet>

            <SearchBar isStringSearch={true} />

            {/* Carosello hero gestito dagli admin; senza slide pubblicate mostra il vecchio hero statico */}
            <HeroCarousel refreshSignal={homeRefreshSignal} />

            <LastFiveSection refreshSignal={homeRefreshSignal} />

            {/* <ActivityTypeSection /> */}
            <ActivityIconSection />

            <AdviceCategorySection />

            {/* <RegionSection /> */}
            <RegionIconSection />
            
            {/* Sezione "Non trovi il tuo posto Wild preferito? Condividilo con noi" — disattivata 2026-09-07
                su richiesta cliente; per riattivarla ripristinare anche l'import in cima al file */}
            {/* <HomepageWildSection /> */}


            {/* Shop */}
            {/* <ShopSection /> */}

            {/* OutdoorAdvices */}
            {/* <OutdoorAdvices /> */}

            {/* Download app dagli store */}
            <DownloadAppFromStore />
            {/* Vecchia promo PWA "Aggiungi alla Home" (sostituita da DownloadAppFromStore) */}
            {/* <DownloadAppSection /> */}

            <HomepageOwnerSection />

            <PartnerBrands />

            <SwisstainableSection />

        </PageContainer>
    )
}

export default HomePage;